//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    headerImg: require('~/assets/img/lid-worden.jpg'),
  }),
};
